import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42efd9ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title header-title mt-3" }, "配信設定")
], -1))
const _hoisted_2 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("配信頻度設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_4 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_5 = { class: "flex flex-wrap gap-3" }
const _hoisted_6 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_7 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_8 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_9 = { class: "flex align-items-center radio-wrapper__custom ml-5" }
const _hoisted_10 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_11 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_12 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_13 = { class: "col-12 d-flex justify-content-start align-items-baseline" }
const _hoisted_14 = { class: "ml-2 -mr-2 hour-minute-container" }
const _hoisted_15 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("配信タイプ設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_17 = {
  key: 0,
  class: "p-error text-sm mt-3 ml-2 d-block"
}
const _hoisted_18 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_19 = { class: "flex flex-wrap gap-3" }
const _hoisted_20 = {
  key: 0,
  class: "align-items-center radio-wrapper__custom col-4"
}
const _hoisted_21 = { class: "d-flex mr-5" }
const _hoisted_22 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_23 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/text.png",
  alt: "Text Description",
  class: "mt-5 mr-5 image-container"
}, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "align-items-center radio-wrapper__custom col-4"
}
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_28 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/textLink.png",
  alt: "Text Description",
  class: "mt-5 image-container"
}, null, -1))
const _hoisted_30 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_31 = { class: "flex flex-wrap gap-3" }
const _hoisted_32 = {
  key: 0,
  class: "align-items-center radio-wrapper__custom col-4"
}
const _hoisted_33 = { class: "d-flex mr-5" }
const _hoisted_34 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_35 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/textImage.png",
  alt: "Text Description",
  class: "mt-5 mr-5 image-container"
}, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "align-items-center radio-wrapper__custom col-4"
}
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_40 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/textUrlImage.png",
  alt: "Text Description",
  class: "mt-5 image-container"
}, null, -1))
const _hoisted_42 = {
  key: 0,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_44 = {
  key: 0,
  class: "grid mt-5 mb-5 justify-content-center"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_46 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_48 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, onBeforeUnmount, onMounted } from "vue";
import { get, set, useDateFormat } from "@vueuse/core";
import { onBeforeRouteLeave, useRouter } from "vue-router";

// PrimeVueコンポーネントのインポート
import RadioButton from "primevue/radiobutton";
import Calendar from "primevue/calendar";
import Toast from "primevue/toast";

// 定数・型定義のインポート
import { BookingHourOptions } from "@/clinic/typings/enums/booking";
import { DATE_ISO_FORMAT, TIME_HOUR_FORMAT, TIME_MINUTE_FORMAT } from "@/clinic/typings/constants/booking";

// サービス・ユーティリティのインポート
import { useStore } from "vuex";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { useToast } from "primevue/usetoast";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DeliverySetting',
  props: {
    isEdit: { type: Boolean },
    finalSetting: { type: Boolean },
    distributionGroupId: null,
    deliverySetting: null
  },
  emits: ["resourcesFn", "saveDeliverySetting", "changeTargetViewType"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 編集モードかどうか */
  isEdit: boolean;
  /** 最終設定モードかどうか */
  finalSetting: boolean;
  /** 配信グループID */
  distributionGroupId: string | number;
  /** 配信設定情報 */
  deliverySetting: {
    delivery_type: number;
    message_type: number;
    send_at: Date;
  };
};

/**
 * 配信設定コンポーネント
 *
 * このコンポーネントは配信グループの配信設定を管理し、
 * 以下の機能を提供します：
 * - 配信頻度設定（今すぐ配信 / 予約配信）
 * - 配信日時設定
 * - 配信タイプ設定（テキスト、テキスト+URL、テキスト+画像、テキスト+URL+画像）
 * - 下書き保存機能
 * - ページ離脱時の警告
 *
 * @component DeliverySetting
 * @description 配信グループの配信設定を管理するコンポーネント
 */

// Vue関連のインポート


/**
 * Vuexストア
 * @type {Store}
 */
const store = useStore();

/**
 * クリニックID
 * @type {Ref<string>}
 */
const clinicId = ref("");

/**
 * トースト通知
 * @type {UseToast}
 */
const toast = useToast();

/**
 * ルーター
 * @type {Router}
 */
const router = useRouter();

/**
 * 次のルート
 * @type {Ref<string | null>}
 */
const nextRoute = ref<string | null>(null);

/**
 * 既に下書き保存済みかどうか
 * @type {Ref<boolean>}
 */
const isAlreadySaveDraft = ref(false);

/**
 * ページ離脱許可フラグ
 * @type {Ref<boolean>}
 */
const hasPermissionRedirect = ref(false);

/**
 * ページ離脱警告表示フラグ
 * @type {Ref<boolean>}
 */
const warningRedirectPage = ref(false);

/**
 * イベントエミッター
 */


/**
 * 分選択オプション
 * @type {Array<{name: string, value: string}>}
 */
const BookingMinuteOptions = Array.from({ length: 60 }, (_, index) => ({
  name: `${index.toString().padStart(2, "0")}分`,
  value: `${index.toString().padStart(2, "0")}`,
}));

/**
 * 配信日
 * @type {Ref<string>}
 */
const deliveryDate = props.deliverySetting?.send_at
  ? ref(get(useDateFormat(props.deliverySetting?.send_at, DATE_ISO_FORMAT)))
  : ref(get(useDateFormat(Date.now(), DATE_ISO_FORMAT)));

/**
 * 配信時間（時）
 * @type {Ref<string>}
 */
const deliveryHour = ref(get(useDateFormat(props.deliverySetting?.send_at, TIME_HOUR_FORMAT)));

/**
 * 配信時間（分）
 * @type {Ref<string>}
 */
const deliveryMinute = ref(get(useDateFormat(props.deliverySetting?.send_at, TIME_MINUTE_FORMAT)));

/**
 * 配信タイプ（1: 今すぐ配信, 2: 予約配信）
 * @type {Ref<number>}
 */
const deliveryType = ref<number>(props.deliverySetting?.delivery_type || 1);

/**
 * メッセージオプション（1-4）
 * @type {Ref<number>}
 */
const messageOption = ref<number>(props.deliverySetting?.message_type || 1);

/**
 * 戻る警告ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const warningReturnVisible = ref(false);

/**
 * 下書き保存完了ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const saveDraftVisible = ref(false);

/**
 * 配信設定エラー
 * @type {Ref<Record<string, any>>}
 */
const deliverySettingErrors = ref<Record<string, any>>({});

/**
 * 戻るボタンクリック時の処理
 */
const handleBackButton = () => {
  if (isAlreadySaveDraft.value) {
    previousStep();
  } else {
    warningReturnVisible.value = true;
  }
};

/**
 * 前のステップに戻る処理
 */
const previousStep = () => {
  warningReturnVisible.value = false;
  emits("changeTargetViewType", "setting");
  emits("resourcesFn", 2);
};

/**
 * TOPページに戻る処理
 */
const returnTop = () => {
  set(hasPermissionRedirect, true);
  warningReturnVisible.value = false;
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
};

/**
 * 現在のページに戻る処理
 */
const returnCurrentPage = () => {
  warningReturnVisible.value = false;
  saveDraftVisible.value = false;
};

/**
 * パラメータを構築する処理
 * @returns {Object} 配信設定パラメータ
 */
const handleParams = () => {
  let date;
  if (deliveryType.value === 2) {
    date = new Date(deliveryDate.value);
    date.setHours(Number(deliveryHour.value));
    date.setMinutes(Number(deliveryMinute.value));
  } else {
    date = new Date();
  }

  return {
    delivery_type: deliveryType.value,
    send_at: date,
    message_type: messageOption.value,
  };
};

/**
 * 下書き保存用パラメータを構築する処理
 * @returns {Object} 下書き保存用パラメータ
 */
const saveDraftParams = () => ({
  ...handleParams(),
  status: 5,
});

/**
 * 次のステップに進む処理
 */
const next = async () => {
  try {
    const body = handleParams();
    if (body.send_at.getTime() <= Date.now() && deliveryType.value == 2) {
      notityErrorMsg(toast, "無効な送信時刻です");
      return;
    }
    const params = { clinic_id: clinicId.value };
    const response = await DistributionGroupService.updateDeliverySettings(props.distributionGroupId, params, body);
    emits("saveDeliverySetting", 4, response.data.value);
  } catch (error: any) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    document.getElementById("step-setting")?.scrollIntoView();
    deliverySettingErrors.value = error.response.data.errors;
  }
};

/**
 * 下書き保存の処理
 * @returns {Promise<any>} APIレスポンス
 */
const handleSaveDraft = async () => {
  const body = saveDraftParams();
  if (body.send_at.getTime() <= Date.now() && deliveryType.value == 2) {
    notityErrorMsg(toast, "無効な送信時刻です");
    document.getElementById("step-setting")?.scrollIntoView();
    return;
  }
  const params = { clinic_id: clinicId.value };
  return await DistributionGroupService.updateDeliverySettings(props.distributionGroupId, params, body);
};

/**
 * 下書き保存の実行処理
 */
const saveDraft = async () => {
  try {
    set(deliverySettingErrors, {});
    const response = await handleSaveDraft();
    if (!response) return;

    set(isAlreadySaveDraft, true);
    emits("saveDeliverySetting", 3, response.data.value);
    if (get(warningReturnVisible)) {
      previousStep();
    } else {
      set(warningReturnVisible, false);
      set(saveDraftVisible, true);
    }
  } catch (error: any) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    document.getElementById("step-setting")?.scrollIntoView();
    warningReturnVisible.value = false;
    deliverySettingErrors.value = error.response.data.errors;
  }
};

/**
 * クリニック情報を読み込む処理
 */
const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

/**
 * ページ離脱時の処理
 * @param {BeforeUnloadEvent} event - ページ離脱イベント
 */
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

/**
 * ページ離脱時の下書き保存処理
 */
const saveDraftWhenRedirect = async () => {
  try {
    await handleSaveDraft();
    saveDraftVisible.value = false;
    set(hasPermissionRedirect, true);
    if (get(nextRoute)) {
      router.push(nextRoute.value!);
    }
  } catch (error: any) {
    warningRedirectPage.value = false;
    deliverySettingErrors.value = error.response.data.errors;
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  }
};

/**
 * ルート離脱時の処理
 */
onBeforeRouteLeave((to, from, next) => {
  if (props.finalSetting) {
    next();
    return;
  }

  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

/**
 * ページ離脱時の削除処理
 */
const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    if (get(nextRoute)) {
      router.push(nextRoute.value!);
    }
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * コンポーネントアンマウント時の処理
 */
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

/**
 * コンポーネントマウント時の処理
 */
onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  document.getElementById("step-setting")?.scrollIntoView();
});

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  set(hasPermissionRedirect, false);
  await loadClinicInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-content-wrapper", { 'pointer-events-none': props.finalSetting }])
    }, [
      _createVNode(_component_Card, { class: "mb-5 mt-3 border-round-lg" }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "period-setting",
                    name: "display_price",
                    value: 1
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "display-price",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 1 }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (deliveryType.value = 1))
                  }, [
                    (deliveryType.value == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8)),
                    _createTextVNode(" 今すぐ配信 ")
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "hide-price",
                    name: "display_price",
                    value: 2
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "hide-price",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 2 }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (deliveryType.value = 2))
                  }, [
                    (deliveryType.value == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11)),
                    _createTextVNode(" 予約配信 ")
                  ], 2)
                ])
              ]),
              (deliverySettingErrors.value?.delivery_type)
                ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(deliverySettingErrors.value.delivery_type[0]), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Button, {
                label: "配信日時",
                class: _normalizeClass(["mr-2 target-button send-later-btn", { 'send-later-btn-bg': deliveryType.value == 2 }]),
                disabled: deliveryType.value != 2
              }, null, 8, ["class", "disabled"]),
              _createVNode(_unref(Calendar), {
                id: "deliveryDate",
                modelValue: _unref(deliveryDate),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(deliveryDate) ? (deliveryDate).value = $event : null)),
                "aria-describedby": "deliveryDate-help",
                type: "date",
                size: "large",
                showIcon: "",
                placeholder: "yyyy/mm/dd",
                dateFormat: "yy/mm/dd",
                disabled: deliveryType.value != 2
              }, null, 8, ["modelValue", "disabled"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Dropdown, {
                  modelValue: deliveryHour.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((deliveryHour).value = $event)),
                  options: _unref(BookingHourOptions),
                  optionLabel: "name",
                  optionValue: "value",
                  class: "mr-2 max-w-6rem font-normal",
                  inputProps: { class: 'font-light text-black20 text-sm' },
                  disabled: deliveryType.value != 2
                }, null, 8, ["modelValue", "options", "disabled"]),
                _createTextVNode(" : "),
                _createVNode(_component_Dropdown, {
                  modelValue: deliveryMinute.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((deliveryMinute).value = $event)),
                  options: _unref(BookingMinuteOptions),
                  optionLabel: "name",
                  optionValue: "value",
                  class: "mr-2 ml-2 max-w-6rem font-normal",
                  inputProps: { class: 'font-light text-black20 text-sm' },
                  disabled: deliveryType.value != 2
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            (deliverySettingErrors.value?.message_type)
              ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(deliverySettingErrors.value.message_type[0]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (props.finalSetting == false || messageOption.value == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: messageOption.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((messageOption).value = $event)),
                          inputId: "message-option-1",
                          name: "message_option_1",
                          value: 1,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (messageOption.value = 1))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "message-option-1",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': messageOption.value == 1 }])
                        }, [
                          (messageOption.value == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23)),
                          _createTextVNode(" テキストメッセージ ")
                        ], 2)
                      ]),
                      _hoisted_24
                    ]))
                  : _createCommentVNode("", true),
                (props.finalSetting == false || messageOption.value == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: messageOption.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((messageOption).value = $event)),
                          inputId: "message-option-2",
                          name: "message_option_2",
                          value: 2,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (messageOption.value = 2))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "message-option-2",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': messageOption.value == 2 }])
                        }, [
                          (messageOption.value == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28)),
                          _createTextVNode(" テキスト＋URLリンクメッセージ ")
                        ], 2)
                      ]),
                      _hoisted_29
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (props.finalSetting == false || messageOption.value == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: messageOption.value,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((messageOption).value = $event)),
                          inputId: "message-option-3",
                          name: "message_option_3",
                          value: 3,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (messageOption.value = 3))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "message-option-3",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': messageOption.value == 3 }])
                        }, [
                          (messageOption.value == 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                            : (_openBlock(), _createElementBlock("span", _hoisted_35)),
                          _createTextVNode(" テキスト＋画像メッセージ ")
                        ], 2)
                      ]),
                      _hoisted_36
                    ]))
                  : _createCommentVNode("", true),
                (props.finalSetting == false || messageOption.value == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_unref(RadioButton), {
                          modelValue: messageOption.value,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((messageOption).value = $event)),
                          inputId: "message-option-4",
                          name: "message_option_4",
                          value: 4,
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (messageOption.value = 4))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", {
                          for: "message-option-4",
                          class: _normalizeClass(["flex algin-items-center", { 'text-orange': messageOption.value == 4 }])
                        }, [
                          (messageOption.value == 4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                            : (_openBlock(), _createElementBlock("span", _hoisted_40)),
                          _createTextVNode(" テキスト＋URLリンク＋画像メッセージ ")
                        ], 2)
                      ]),
                      _hoisted_41
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      (props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createVNode(_component_Button, {
              class: "col-2 black-btn ml-5",
              label: "前設定へ戻る",
              onClick: handleBackButton
            }),
            _createVNode(_component_Button, {
              class: "col-2 temp-save-btn ml-5",
              label: "下書き保存",
              onClick: saveDraft
            }),
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5",
              label: "メッセージ設定へ進む",
              onClick: next
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Dialog, {
      visible: warningReturnVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((warningReturnVisible).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_43
      ]),
      default: _withCtx(() => [
        (props.finalSetting == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createVNode(_component_Button, {
                class: "col-3 temp-save-btn mr-5",
                label: "下書き保存",
                onClick: saveDraft
              }),
              _createVNode(_component_Button, {
                class: "col-3 black-btn mr-5",
                label: "戻る",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (warningReturnVisible.value = false))
              }),
              _createVNode(_component_Button, {
                class: "col-3 confirm-delete-btn",
                label: "破棄する",
                onClick: previousStep
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0 text-center",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_45
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: saveDraftWhenRedirect
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: saveDraftVisible.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((saveDraftVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0 text-center",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_47
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "TOPに戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "作成を続ける",
            onClick: returnCurrentPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})